import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Divider } from '../components/ui/Divider';
export function EmotionalClosing() {
  return <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-116">
      <Divider className="mb-16" data-id="element-117" />

      <FadeIn data-id="element-118">
        <div className="bg-brand-rose-light/20 rounded-3xl p-8 md:p-12 text-center mb-16 relative" data-id="element-119">
          <div className="text-6xl font-serif text-brand-rose/30 absolute top-4 left-6 leading-none" data-id="element-120">
            "
          </div>
          <p className="text-2xl md:text-3xl font-serif text-brand-burgundy leading-snug relative z-10 italic" data-id="element-121">
            Imagina abrir este diario dentro de 10 años junto a tu hijo y
            mostrarle cuánto lo amabas incluso antes de conocerlo.
          </p>
          <div className="text-6xl font-serif text-brand-rose/30 absolute bottom-[-1rem] right-6 leading-none rotate-180" data-id="element-122">
            "
          </div>
        </div>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-123">
        <FadeIn delay={0.2} data-id="element-124">
          <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/wzR8d9QbJG4MxuhzGF8mTp/ChatGPT_Image_Jun_21,_2026,_10_43_10_PM.png" alt="Mamá leyendo el diario con su hijo años después" className="w-full h-auto object-cover" data-id="element-126" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="space-y-6 text-center md:text-left" data-id="element-127">
          <h3 className="text-3xl font-serif text-brand-burgundy" data-id="element-128">
            Empieza hoy.
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-129">
            Tu embarazo durará solamente 40 semanas. Pero los recuerdos que
            construyas durante ese tiempo pueden durar toda una vida.
          </p>
        </FadeIn>
      </div>
    </section>;
}